import { format, parseISO } from 'date-fns';

/**
 * Formats an ISO date string using date-fns. Returns the raw string if parsing
 * fails, and `null` when the input is null/empty. A single shared helper used
 * across the public-share section components.
 */
export function formatIsoDate(
  raw: string | null | undefined,
  fmt: string = 'MMM d, yyyy',
): string | null {
  if (!raw) return null;
  try {
    return format(parseISO(raw), fmt);
  } catch {
    return raw;
  }
}
